import { useSyncExternalStore } from 'react';

let open = false;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach(l => l());

export const chatOpenStore = {
	toggle() {
		open = !open;
		emit();
	},
	openChat() {
		open = true;
		emit();
	},
	close() {
		open = false;
		emit();
	}
};

export function useChatOpen(): boolean {
	return useSyncExternalStore(
		cb => {
			listeners.add(cb);
			return () => listeners.delete(cb);
		},
		() => open
	);
}
